import api from '../util/instance';
import { urls } from './Api';

export const getTradeHistory = async (id) => {
    return await api.get(`${urls.tradeHistory}/${id}`);
};
